import React, {
  useState,
  useEffect,
  useContext,
  useMemo,
} from "react";

import {
  Table,
  Segment,
  Input,
  Container,
  Form,
  Button,
  Header,
  Icon,
  Grid,
} from "semantic-ui-react";

import { Link } from "react-router-dom";

import {
  auth,
  db,
} from "../firebase/firebaseConfig";

import Alerta from "../components/Alertas";

import AgregarClientesDb from "../firebase/AgregarClientesDb";

import { Regiones } from "./comunas";

import {
  getDocs,
  collection,
  where,
  query,
} from "firebase/firestore";

import * as FaIcons from "react-icons/fa";

import validarRut from "../funciones/validarRut";

import { UserContext } from "../context/UserContext";

import ExportarExcel from "../funciones/ExportarExcel";

import moment from "moment";

// ==========================================================
// COMPONENTE
// ==========================================================

const Clientes = () => {
  const user = auth.currentUser;
  const { users } = useContext(UserContext);

  // ========================================================
  // DATOS CLIENTE
  // ========================================================

  const [rut, setRut] = useState("");
  const [nombre, setNombre] = useState("");
  const [direccion, setDireccion] = useState("");

  const [telefono, setTelefono] = useState("+56");

  const [correo, setCorreo] = useState("");

  const [region, setRegion] = useState(
    "Arica y Parinacota"
  );

  const [comuna, setComuna] = useState("");

  const [date, setDate] = useState("");

  // ========================================================
  // RESPONSABLE FINANCIERO
  // ========================================================

  const [checked, setChecked] = useState(false);

  const [nomRsf, setNomRsf] = useState("");
  const [dirRsf, setDirRsf] = useState("");
  const [telRsf, setTelRsf] = useState("");

  // ========================================================
  // ALERTAS
  // ========================================================

  const [alerta, cambiarAlerta] = useState({});

  const [
    estadoAlerta,
    cambiarEstadoAlerta,
  ] = useState(false);

  // ========================================================
  // LISTADO
  // ========================================================

  const [buscador, setBuscador] = useState("");

  const [leer, setLeer] = useState([]);

  const [flag, setFlag] = useState(false);

  // ========================================================
  // GUARDADO
  // ========================================================

  const [isSaving, setIsSaving] = useState(false);

  // ========================================================
  // FORMATEAR FECHA
  // ========================================================

  const formatearFecha = (fecha) => {
    if (!fecha) return "-";

    try {
      const dateObj =
        typeof fecha.toDate === "function"
          ? fecha.toDate()
          : new Date(fecha);

      return moment(dateObj).format("DD/MM/YYYY");
    } catch (error) {
      return "-";
    }
  };

  // ========================================================
  // OBTENER CLIENTES
  // ========================================================

  const getData = async () => {
    if (!users?.emp_id) return;

    try {
      const traerClientes =
        collection(db, "clientes");

      const dato = query(
        traerClientes,
        where(
          "emp_id",
          "==",
          users.emp_id
        )
      );

      const data =
        await getDocs(dato);

      const clientes =
        data.docs.map(
          (documento) => ({
            ...documento.data(),
            id: documento.id,
          })
        );

      clientes.sort((a, b) =>
        String(a.nombre || "")
          .localeCompare(
            String(b.nombre || "")
          )
      );

      setLeer(clientes);
    } catch (error) {
      console.error(
        "Error obteniendo clientes:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible cargar los clientes",
      });
    }
  };

  // ========================================================
  // CARGAR CLIENTES
  // ========================================================

  useEffect(() => {
    getData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    flag,
    users?.emp_id,
  ]);

  // ========================================================
  // BUSCADOR
  // ========================================================

  const filtroCliente = useMemo(() => {
    const texto =
      buscador
        .toLowerCase()
        .trim();

    if (!texto) {
      return leer;
    }

    return leer.filter(
      (item) =>
        Object.keys(item).some(
          (key) =>
            String(
              item[key] ?? ""
            )
              .toLowerCase()
              .includes(texto)
        )
    );
  }, [
    leer,
    buscador,
  ]);

  // ========================================================
  // VALIDAR RUT AL SALIR DEL CAMPO
  // ========================================================

  const detectar = async (e) => {
    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    if (
      (e.key === "Enter" ||
        e.key === "Tab") &&
      rut &&
      users?.emp_id
    ) {
      try {
        const rutNormalizado =
          rut
            .trim()
            .toLocaleUpperCase();

        const c = query(
          collection(
            db,
            "clientes"
          ),
          where(
            "emp_id",
            "==",
            users.emp_id
          ),
          where(
            "rut",
            "==",
            rutNormalizado
          )
        );

        const rutCli =
          await getDocs(c);

        if (
          rutCli.docs.length !== 0
        ) {
          cambiarEstadoAlerta(true);

          cambiarAlerta({
            tipo: "error",
            mensaje:
              "Ya existe RUT de cliente",
          });
        }
      } catch (error) {
        console.error(
          "Error validando RUT:",
          error
        );
      }
    }
  };

  // ========================================================
  // CAMBIO REGIÓN
  // ========================================================

  const handleDropdownChange = (
    e,
    { value }
  ) => {
    setRegion(value);
    setComuna("");
  };

  // ========================================================
  // CAMBIO COMUNA
  // ========================================================

  const handleComunaChange = (
    e,
    { value }
  ) => {
    setComuna(value);
  };

  // ========================================================
  // REGIONES
  // ========================================================

  const regionOptions = useMemo(
    () =>
      Regiones.map(
        (d, index) => ({
          key: index + 1,
          text: d.region,
          value: d.region,
        })
      ).sort((a, b) =>
        a.text.localeCompare(
          b.text
        )
      ),
    []
  );

  // ========================================================
  // COMUNAS
  // ========================================================

  const comunaOptions = useMemo(() => {
    const comunas =
      Regiones.find(
        (option) =>
          option.region === region
      )?.comunas || [];

    return comunas
      .map((d, index) => ({
        key: index + 1,
        text: d.name,
        value: d.name,
      }))
      .sort((a, b) =>
        a.text.localeCompare(b.text)
      );
  }, [region]);

  // ========================================================
  // TELÉFONO CLIENTE
  // ========================================================

  const handleTelefono = (e) => {
    let value =
      e.target.value.replace(
        /\D/g,
        ""
      );

    if (
      value.startsWith("56")
    ) {
      value =
        value.slice(2);
    }

    setTelefono(
      "+56" + value
    );
  };

  // ========================================================
  // LIMPIAR FORMULARIO
  // ========================================================

  const limpiarFormulario = () => {
    setRut("");
    setNombre("");
    setDireccion("");
    setTelefono("+56");
    setCorreo("");
    setComuna("");
    setDate("");

    setNomRsf("");
    setDirRsf("");
    setTelRsf("");

    setChecked(false);
  };

  // ========================================================
  // GUARDAR CLIENTE
  // ========================================================

  const handleSubmit = async (e) => {
    e.preventDefault();

    cambiarEstadoAlerta(false);
    cambiarAlerta({});

    if (isSaving) {
      return;
    }

    const rutNormalizado =
      rut
        .trim()
        .toLocaleUpperCase();

    const nombreNormalizado =
      nombre
        .trim()
        .toLocaleUpperCase();

    const direccionNormalizada =
      direccion
        .trim()
        .toLocaleUpperCase();

    const correoNormalizado =
      correo
        .trim()
        .toLocaleLowerCase();

    const expresionRegular =
      /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

    const expresionRegularRut =
      /^[0-9]+[-|‐]{1}[0-9kK]{1}$/;

    // ======================================================
    // RUT
    // ======================================================

    if (!rutNormalizado) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Campo RUT no puede estar vacío",
      });

      return;
    }

    if (
      !expresionRegularRut.test(
        rutNormalizado
      )
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Formato incorrecto de RUT",
      });

      return;
    }

    const temp =
      rutNormalizado.split("-");

    let digito =
      temp[1];

    if (
      digito === "k" ||
      digito === "K"
    ) {
      digito = -1;
    }

    const validaR =
      validarRut(
        rutNormalizado
      );

    if (
      validaR !==
      parseInt(digito, 10)
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "RUT no válido",
      });

      return;
    }

    // ======================================================
    // DATOS CLIENTE
    // ======================================================

    if (!nombreNormalizado) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Campo Nombre no puede estar vacío",
      });

      return;
    }

    if (
      !direccionNormalizada
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Campo Dirección no puede estar vacío",
      });

      return;
    }

    if (
      !telefono ||
      telefono === "+56"
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Campo Teléfono no puede estar vacío",
      });

      return;
    }

    if (
      !expresionRegular.test(
        correoNormalizado
      )
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Favor ingresar un correo válido",
      });

      return;
    }

    if (!region) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Favor seleccionar Región",
      });

      return;
    }

    if (!comuna) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Favor seleccionar Comuna",
      });

      return;
    }

    // ======================================================
    // DUPLICADO LOCAL
    // ======================================================

    const existeLocal =
      leer.some(
        (cli) =>
          String(
            cli.rut || ""
          )
            .trim()
            .toLocaleUpperCase() ===
          rutNormalizado
      );

    if (existeLocal) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "RUT ya existe",
      });

      return;
    }

    // ======================================================
    // RESPONSABLE FINANCIERO
    // ======================================================

    if (
      checked &&
      !nomRsf.trim()
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Campo Nombre Responsable Financiero no puede estar vacío",
      });

      return;
    }

    if (
      checked &&
      !dirRsf.trim()
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Campo Dirección Responsable Financiero no puede estar vacío",
      });

      return;
    }

    if (
      checked &&
      !telRsf.trim()
    ) {
      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "Campo Teléfono Responsable Financiero no puede estar vacío",
      });

      return;
    }

    // ======================================================
    // VALIDACIÓN REAL FIRESTORE
    // ======================================================

    try {
      setIsSaving(true);

      const qRut = query(
        collection(
          db,
          "clientes"
        ),
        where(
          "emp_id",
          "==",
          users.emp_id
        ),
        where(
          "rut",
          "==",
          rutNormalizado
        )
      );

      const rutSnap =
        await getDocs(qRut);

      if (!rutSnap.empty) {
        cambiarEstadoAlerta(true);

        cambiarAlerta({
          tipo: "error",
          mensaje:
            "RUT ya existe",
        });

        return;
      }

      // ====================================================
      // GUARDAR
      // ====================================================

      const fechaActual =
        new Date();

      await AgregarClientesDb({
        emp_id:
          users.emp_id,

        rut:
          rutNormalizado,

        nombre:
          nombreNormalizado,

        direccion:
          direccionNormalizada,

        fnaci:
          date
            ? new Date(date)
            : null,

        telefono:
          telefono.trim(),

        region,

        comuna,

        correo:
          correoNormalizado,

        nomrsf:
          checked
            ? nomRsf
              .trim()
              .toLocaleUpperCase()
            : "",

        dirrsf:
          checked
            ? dirRsf
              .trim()
              .toLocaleUpperCase()
            : "",

        telrsf:
          checked
            ? telRsf.trim()
            : "",

        userAdd:
          user?.email || "",

        userMod:
          user?.email || "",

        fechaAdd:
          fechaActual,

        fechaMod:
          fechaActual,
      });

      limpiarFormulario();

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "exito",
        mensaje:
          "Cliente registrado exitosamente",
      });

      setFlag(
        (prev) => !prev
      );
    } catch (error) {
      console.error(
        "Error al guardar cliente:",
        error
      );

      cambiarEstadoAlerta(true);

      cambiarAlerta({
        tipo: "error",
        mensaje:
          "No fue posible guardar el cliente",
      });
    } finally {
      setIsSaving(false);
    }
  };

  // ========================================================
  // EXPORTAR EXCEL
  // ========================================================

  const ExportarXls = () => {
    if (
      leer.length === 0
    ) {
      return;
    }

    const columnsToShow = [
      "rut",
      "nombre",
      "direccion",
      "telefono",
      "correo",
      "region",
      "comuna",
      "nomrsf",
      "dirrsf",
      "telrsf",
    ];

    const excelBlob =
      ExportarExcel(
        leer,
        columnsToShow
      );

    const excelURL =
      URL.createObjectURL(
        excelBlob
      );

    const downloadLink =
      document.createElement(
        "a"
      );

    downloadLink.href =
      excelURL;

    downloadLink.download =
      "clientes.xlsx";

    document.body.appendChild(
      downloadLink
    );

    downloadLink.click();

    document.body.removeChild(
      downloadLink
    );

    URL.revokeObjectURL(
      excelURL
    );
  };

  // ========================================================
  // RENDER
  // ========================================================

  return (
    <Container
      fluid
      style={{
        maxWidth: 1400,
        padding: "24px 28px",
        margin: "0 auto",
        background: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      {/* ================================================== */}
      {/* ENCABEZADO */}
      {/* ================================================== */}

      <div
        style={{
          display: "flex",
          justifyContent:
            "space-between",
          alignItems: "center",
          marginBottom: 20,
          gap: 20,
          flexWrap: "wrap",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              minWidth: 48,
              borderRadius: 12,
              background:
                "#e5f7f7",
              display: "flex",
              alignItems:
                "center",
              justifyContent:
                "center",
            }}
          >
            <Icon
              name="users"
              style={{
                margin: 0,
                color:
                  "#0d9da5",
                fontSize: 21,
              }}
            />
          </div>

          <div>
            <Header
              as="h2"
              style={{
                margin: 0,
                color:
                  "#172b4d",
                fontSize: 24,
                fontWeight: 700,
              }}
            >
              Clientes
            </Header>

            <div
              style={{
                color:
                  "#8793a5",
                fontSize: 13,
                marginTop: 4,
              }}
            >
              Registra y administra los clientes de la empresa
            </div>
          </div>
        </div>

        <Button
          type="button"
          onClick={ExportarXls}
          disabled={
            leer.length === 0
          }
          style={{
            background:
              "#ffffff",
            color:
              "#526273",
            border:
              "1px solid #d7dee7",
            borderRadius: 6,
            boxShadow: "none",
          }}
        >
          <Icon
            name="file excel outline"
            style={{
              color:
                "#21ba45",
            }}
          />

          Exportar Excel
        </Button>
      </div>

      {/* ================================================== */}
      {/* FORMULARIO */}
      {/* ================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding: 0,
          background:
            "#ffffff",
          overflow: "visible",
          marginBottom: 14,
        }}
      >
        {/* HEADER CARD */}

        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display: "flex",
            alignItems:
              "center",
            gap: 9,
            color:
              "#253858",
            fontWeight: 600,
          }}
        >
          <Icon
            name="user plus"
            style={{
              color:
                "#0d9da5",
            }}
          />

          Registrar cliente
        </div>

        <div
          style={{
            padding: 18,
          }}
        >
          <Form
            size="small"
            onSubmit={
              handleSubmit
            }
          >
            {/* ============================================ */}
            {/* DATOS PERSONALES */}
            {/* ============================================ */}

            <div
              style={
                sectionTitleStyle
              }
            >
              <Icon
                name="user outline"
                style={{
                  color:
                    "#2185d0",
                }}
              />

              Datos personales
            </div>

            <Grid
              stackable
              columns={3}
            >
              {/* RUT */}

              <Grid.Column>
                <Form.Input
                  label="RUT"
                  fluid
                  icon={
                    <Icon
                      name="address card"
                      style={{
                        color:
                          "#2185d0",
                      }}
                    />
                  }
                  iconPosition="left"
                  placeholder="Ingrese RUT"
                  value={rut}
                  onChange={(e) =>
                    setRut(
                      e.target.value
                    )
                  }
                  onKeyDown={
                    detectar
                  }
                />
              </Grid.Column>

              {/* NOMBRE */}

              <Grid.Column>
                <Form.Input
                  label="Nombre"
                  fluid
                  icon={
                    <Icon
                      name="user"
                      style={{
                        color:
                          "#0d9da5",
                      }}
                    />
                  }
                  iconPosition="left"
                  placeholder="Ingrese Nombre"
                  value={nombre}
                  onChange={(e) =>
                    setNombre(
                      e.target.value
                    )
                  }
                />
              </Grid.Column>

              {/* NACIMIENTO */}

              <Grid.Column>
                <Form.Input
                  label="Fecha de Nacimiento"
                  fluid
                  type="date"
                  icon={
                    <Icon
                      name="calendar alternate outline"
                      style={{
                        color:
                          "#f2711c",
                      }}
                    />
                  }
                  iconPosition="left"
                  value={date}
                  onChange={(e) =>
                    setDate(
                      e.target.value
                    )
                  }
                />
              </Grid.Column>
            </Grid>

            {/* ============================================ */}
            {/* CONTACTO */}
            {/* ============================================ */}

            <div
              style={{
                ...sectionTitleStyle,
                marginTop: 18,
              }}
            >
              <Icon
                name="address book outline"
                style={{
                  color:
                    "#6435c9",
                }}
              />

              Contacto
            </div>

            <Grid
              stackable
              columns={3}
            >
              {/* DIRECCIÓN */}

              <Grid.Column>
                <Form.Input
                  label="Dirección"
                  fluid
                  icon={
                    <Icon
                      name="map marker alternate"
                      style={{
                        color:
                          "#f2711c",
                      }}
                    />
                  }
                  iconPosition="left"
                  placeholder="Ingrese Dirección"
                  value={direccion}
                  onChange={(e) =>
                    setDireccion(
                      e.target.value
                    )
                  }
                />
              </Grid.Column>

              {/* TELÉFONO */}

              <Grid.Column>
                <Form.Input
                  label="Teléfono"
                  fluid
                  icon={
                    <Icon
                      name="phone"
                      style={{
                        color:
                          "#21ba45",
                      }}
                    />
                  }
                  iconPosition="left"
                  placeholder="+569..."
                  value={telefono}
                  onChange={
                    handleTelefono
                  }
                />
              </Grid.Column>

              {/* EMAIL */}

              <Grid.Column>
                <Form.Input
                  label="Email"
                  fluid
                  icon={
                    <Icon
                      name="mail"
                      style={{
                        color:
                          "#6435c9",
                      }}
                    />
                  }
                  iconPosition="left"
                  placeholder="cliente@correo.cl"
                  value={correo}
                  onChange={(e) =>
                    setCorreo(
                      e.target.value
                    )
                  }
                />
              </Grid.Column>
            </Grid>

            {/* ============================================ */}
            {/* UBICACIÓN */}
            {/* ============================================ */}

            <div
              style={{
                ...sectionTitleStyle,
                marginTop: 18,
              }}
            >
              <Icon
                name="map outline"
                style={{
                  color:
                    "#f2711c",
                }}
              />

              Ubicación
            </div>

            <Grid
              stackable
              columns={2}
            >
              <Grid.Column>
                <Form.Dropdown
                  label="Región"
                  placeholder="Seleccione Región"
                  fluid
                  search
                  selection
                  options={
                    regionOptions
                  }
                  value={region}
                  onChange={
                    handleDropdownChange
                  }
                />
              </Grid.Column>

              <Grid.Column>
                <Form.Dropdown
                  label="Comuna"
                  placeholder="Seleccione Comuna"
                  fluid
                  search
                  selection
                  options={
                    comunaOptions
                  }
                  value={comuna}
                  onChange={
                    handleComunaChange
                  }
                />
              </Grid.Column>
            </Grid>

            {/* ============================================ */}
            {/* RESPONSABLE FINANCIERO */}
            {/* ============================================ */}

            <div
              style={{
                ...sectionTitleStyle,
                marginTop: 18,
                justifyContent:
                  "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems:
                    "center",
                  gap: 4,
                }}
              >
                <Icon
                  name="money bill alternate outline"
                  style={{
                    color:
                      "#21ba45",
                  }}
                />

                Responsable financiero
              </div>

              <Form.Checkbox
                label="Registrar responsable financiero"
                checked={
                  checked
                }
                onChange={(
                  e,
                  { checked }
                ) => {
                  setChecked(
                    checked
                  );

                  if (!checked) {
                    setNomRsf("");
                    setDirRsf("");
                    setTelRsf("");
                  }
                }}
                style={{
                  textTransform:
                    "none",
                  letterSpacing: 0,
                  fontWeight: 400,
                }}
              />
            </div>

            {checked && (
              <div
                style={{
                  background:
                    "#f8fafc",
                  border:
                    "1px solid #e8edf3",
                  borderRadius: 7,
                  padding: 14,
                }}
              >
                <Grid
                  stackable
                  columns={3}
                >
                  <Grid.Column>
                    <Form.Input
                      label="Nombre Responsable"
                      fluid
                      icon={
                        <Icon
                          name="user"
                          style={{
                            color:
                              "#2185d0",
                          }}
                        />
                      }
                      iconPosition="left"
                      placeholder="Ingrese Nombre"
                      value={nomRsf}
                      onChange={(e) =>
                        setNomRsf(
                          e.target.value
                        )
                      }
                    />
                  </Grid.Column>

                  <Grid.Column>
                    <Form.Input
                      label="Dirección Responsable"
                      fluid
                      icon={
                        <Icon
                          name="map marker alternate"
                          style={{
                            color:
                              "#f2711c",
                          }}
                        />
                      }
                      iconPosition="left"
                      placeholder="Ingrese Dirección"
                      value={dirRsf}
                      onChange={(e) =>
                        setDirRsf(
                          e.target.value
                        )
                      }
                    />
                  </Grid.Column>

                  <Grid.Column>
                    <Form.Input
                      label="Teléfono Responsable"
                      fluid
                      icon={
                        <Icon
                          name="phone"
                          style={{
                            color:
                              "#21ba45",
                          }}
                        />
                      }
                      iconPosition="left"
                      placeholder="Ingrese Teléfono"
                      value={telRsf}
                      onChange={(e) =>
                        setTelRsf(
                          e.target.value
                        )
                      }
                    />
                  </Grid.Column>
                </Grid>
              </div>
            )}

            {/* ============================================ */}
            {/* BOTÓN */}
            {/* ============================================ */}

            <div
              style={{
                display: "flex",
                justifyContent:
                  "flex-end",
                marginTop: 20,
              }}
            >
              <Button
                type="submit"
                loading={isSaving}
                disabled={
                  isSaving
                }
                style={{
                  minWidth: 150,
                  height: 38,
                  borderRadius: 6,
                  fontWeight: 600,
                  background:
                    "#0d9da5",
                  color:
                    "#ffffff",
                  boxShadow:
                    "none",
                }}
              >
                {!isSaving && (
                  <Icon name="save" />
                )}

                Guardar Cliente
              </Button>
            </div>
          </Form>
        </div>
      </Segment>

      {/* ================================================== */}
      {/* LISTADO */}
      {/* ================================================== */}

      <Segment
        style={{
          borderRadius: 8,
          border:
            "1px solid #e5e9ef",
          boxShadow:
            "0 2px 6px rgba(0,0,0,0.04)",
          padding: 0,
          background:
            "#ffffff",
          overflow: "hidden",
        }}
      >
        {/* HEADER LISTADO */}

        <div
          style={{
            padding:
              "14px 18px",
            borderBottom:
              "1px solid #edf0f4",
            display: "flex",
            justifyContent:
              "space-between",
            alignItems:
              "center",
            gap: 15,
            flexWrap: "wrap",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems:
                "center",
              gap: 8,
              color:
                "#253858",
              fontWeight: 600,
            }}
          >
            <Icon
              name="list"
              style={{
                color:
                  "#0d9da5",
              }}
            />

            Clientes registrados

            <span
              style={{
                marginLeft: 8,
                color:
                  "#98a1af",
                fontSize: 11,
                fontWeight: 400,
              }}
            >
              {
                filtroCliente.length
              }{" "}
              registros
            </span>
          </div>

          <div
            style={{
              width: 350,
              maxWidth: "100%",
            }}
          >
            <Input
              fluid
              icon={
                <Icon
                  name="search"
                  style={{
                    color:
                      "#2185d0",
                  }}
                />
              }
              iconPosition="left"
              placeholder="Buscar clientes..."
              value={buscador}
              onChange={(e) =>
                setBuscador(
                  e.target.value
                )
              }
            />
          </div>
        </div>

        {/* ================================================= */}
        {/* TABLA */}
        {/* ================================================= */}

        <div
          style={{
            maxHeight: 520,
            overflowY: "auto",
            overflowX: "auto",
          }}
        >
          <Table
            celled
            selectable
            compact
            unstackable
            style={{
              margin: 0,
              border: 0,
              borderRadius: 0,
              minWidth: 1100,
              fontSize: 12,
            }}
          >
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell
                  width={1}
                  textAlign="center"
                  style={stickyTh}
                >
                  N°
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={4}
                  style={stickyTh}
                >
                  Nombre Cliente
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={2}
                  style={stickyTh}
                >
                  RUT
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={2}
                  style={stickyTh}
                >
                  Fecha Nacimiento
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={4}
                  style={stickyTh}
                >
                  Dirección
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={2}
                  style={stickyTh}
                >
                  Teléfono
                </Table.HeaderCell>

                <Table.HeaderCell
                  width={2}
                  textAlign="center"
                  style={stickyTh}
                >
                  Acción
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {filtroCliente.length ===
                0 ? (
                <Table.Row>
                  <Table.Cell
                    colSpan={7}
                    textAlign="center"
                    style={{
                      padding: 32,
                      color:
                        "#8995a3",
                    }}
                  >
                    <Icon
                      name="info circle"
                      style={{
                        color:
                          "#2185d0",
                      }}
                    />

                    No existen clientes para mostrar
                  </Table.Cell>
                </Table.Row>
              ) : (
                filtroCliente.map(
                  (
                    item,
                    index
                  ) => (
                    <Table.Row
                      key={
                        item.id
                      }
                    >
                      <Table.Cell
                        textAlign="center"
                      >
                        {index + 1}
                      </Table.Cell>

                      <Table.Cell>
                        <div
                          style={{
                            fontWeight:
                              600,
                            color:
                              "#344563",
                            whiteSpace:
                              "normal",
                            wordBreak:
                              "break-word",
                          }}
                        >
                          {item.nombre ||
                            "-"}
                        </div>
                      </Table.Cell>

                      <Table.Cell>
                        {item.rut ||
                          "-"}
                      </Table.Cell>

                      <Table.Cell>
                        {item.fnaci
                          ? formatearFecha(
                            item.fnaci
                          )
                          : "-"}
                      </Table.Cell>

                      <Table.Cell
                        style={{
                          whiteSpace:
                            "normal",
                          wordBreak:
                            "break-word",
                        }}
                      >
                        {item.direccion ||
                          "-"}
                      </Table.Cell>

                      <Table.Cell>
                        {item.telefono ||
                          "-"}
                      </Table.Cell>

                      <Table.Cell textAlign="center">
                        <Link
                          to={`/actualizacliente/${item.id}`}
                        >
                          <Button
                            basic
                            icon
                            size="small"
                            title="Editar cliente"
                            style={{
                              borderRadius: 6,
                              color:
                                "#2185d0",
                              borderColor:
                                "#b9d6ee",
                              background:
                                "#f7fbff",
                            }}
                          >
                            <FaIcons.FaRegEdit
                              style={{
                                fontSize: 16,
                                color:
                                  "#2185d0",
                              }}
                            />
                          </Button>
                        </Link>
                      </Table.Cell>
                    </Table.Row>
                  )
                )
              )}
            </Table.Body>
          </Table>
        </div>

        {/* ================================================= */}
        {/* PIE */}
        {/* ================================================= */}

        {leer.length > 0 && (
          <div
            style={{
              padding:
                "12px 18px",
              borderTop:
                "1px solid #edf0f4",
              color:
                "#697586",
              fontSize: 12,
            }}
          >
            Mostrando{" "}
            <strong>
              {
                filtroCliente.length
              }
            </strong>{" "}
            de{" "}
            <strong>
              {leer.length}
            </strong>{" "}
            clientes
          </div>
        )}
      </Segment>

      {/* ================================================== */}
      {/* ALERTA */}
      {/* ================================================== */}

      <Alerta
        tipo={alerta.tipo}
        mensaje={alerta.mensaje}
        estadoAlerta={
          estadoAlerta
        }
        cambiarEstadoAlerta={
          cambiarEstadoAlerta
        }
      />
    </Container>
  );
};

// ==========================================================
// ESTILOS
// ==========================================================

const sectionTitleStyle = {
  color: "#344563",
  fontSize: 12,
  fontWeight: 700,
  marginBottom: 10,
  marginTop: 2,
  textTransform: "uppercase",
  letterSpacing: "0.3px",
  display: "flex",
  alignItems: "center",
  gap: 4,
};

const stickyTh = {
  position: "sticky",
  top: 0,
  zIndex: 2,
  background: "#f8fafc",
  color: "#344563",
  fontWeight: 600,
};

export default Clientes;